import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getWorkflowProcesses = async (token, params) => {
  const url = 'workflow_processes'
  const apiParams = {
    search: params.search,
    order_by: params.orderBy,
    order_direction: params.orderDirection
  }
  const data = await apiGet({ url, token, params: apiParams })
  return data
}

export default function useWorkflowProcesses({ params, options }) {
  const token = useContext(AuthContext)
  const queryKey = ['workflow-processes', params]
  const queryFn = () => getWorkflowProcesses(token, params)

  return useQuery(queryKey, queryFn, {
    ...options
  })
}
